














import { Vue, Component, Prop } from 'vue-property-decorator'
import { FileInfo, PathController, VFS } from '@/api/types'
import { PageConfig } from '@/store/modules/PageConfigs'

@Component({})
export default class DUDAttachments extends Vue {
  @Prop() files!: FileInfo[]
  @Prop() pageConfig!: PageConfig
  @Prop() pathController!: PathController
  @Prop() root!: FileInfo
  @Prop() vfs!: Promise<VFS>

  async mounted () {
    const scroll = this.$refs.scroller as HTMLElement
    if (scroll) {
      scroll.scrollTop = this.pageConfig.scrollPosition
      scroll.addEventListener('scroll', this.handleScroll)
    }
  }

  handleScroll (event: any) {
    this.$emit('on-scroll', event.target.scrollTop)
  }
}

